const formatterPeso = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
});

export default {
    install: (app, options) => {
        app.config.globalProperties.$filters = {
            age(value) {
                if (value == null) return null;
                var hoy = new Date();
                var cumpleanos = new Date(value);
                var edad = hoy.getFullYear() - cumpleanos.getFullYear();
                var m = hoy.getMonth() - cumpleanos.getMonth();
                if (
                    m < 0 ||
                    (m === 0 && hoy.getDate() < cumpleanos.getDate())
                ) {
                    edad--;
                }
                return edad;
            },
            capitalize(value) {
                return (!value)?null:value[0].toUpperCase() + value.slice(1);
            },
            day(value) {
                const data = new Date(value);
                return moment(data).format("D");
            },
            currentYear() {
                return moment().format("Y");
            },
            dateSql(value, format = "YYYY-MM-DD") {
                if (value == null) return null;
                const data = new Date(value);
                // console.log(moment(data).format(format));
                return moment(data).format(format);
            },
            DateToTime(value) {
                if (value == null) return null;
                return moment(value).format("YYYYMMDD");
            },
            diffTime(value) {
                var fecha1 = moment();
                var fecha2 = moment(value);
                var diff = fecha2.diff(fecha1, "days");
                if (diff < 0) {
                    return "Inactivo";
                } else {
                    return "Activo";
                }
            },
            fixed(value, length = 2) {
                if (value == "" || value == null) return value;
                return Number.parseFloat(value).toFixed(length);
            },
            forHuman(value) {
                const data = new Date(value);
                return moment(data).format("LL");
            },
            floatorzero(value) {
                if (value == "" || value == null) {
                    return 0;
                }
                return parseFloat(value);
            },
            imgspa(value) {
                if (value == "" || value == null) {
                    return value;
                }
                return value.substring(0, 10);
            },
            month(value) {
                const data = new Date(value);
                return moment(data).format("MMM");
            },
            numberFormat(value) {
                if (value == null) return null;
                return formatterPeso.format(value);
            },
            nameFile(value) {
                if (value == null) return null;
                let argument = value.split("/");
                return argument[argument.length - 1];
            },
            publish(value) {
                let status = "No publicado";
                if (value == 1) {
                    status = "publicado";
                }
                return status;
            },
            outHtml(value) {
                if (value == "" || value == null) {
                    return value;
                }
                var re = new RegExp(String.fromCharCode(160), "g");
                value = value.replace(re, " ");
                return value.replace(/<[^>]*>?/g, "");
            },
            resumen(value, length = 450) {
                if (value == "" || value == null) {
                    return value;
                }
                return value.substring(0, length);
            },
            substring(value, length = 150) {
                if (value == "" || value == null) {
                    return value;
                }
                return value.substring(0, length);
            },
            time(value) {
                if (value == "" || value == null) {
                    return value;
                }
                return value.substring(10, 16);
            },
            timeSince(date) {
                const data = new Date(date);
                var seconds = Math.floor((new Date() - data) / 1000);
                var interval = seconds / 31536000;
                if (interval > 1) {
                    return Math.floor(interval) + " Años";
                }
                interval = seconds / 2592000;
                if (interval > 1) {
                    return Math.floor(interval) + " Meses";
                }
                interval = seconds / 86400;
                if (interval > 1) {
                    return Math.floor(interval) + " Días";
                }
                interval = seconds / 3600;
                if (interval > 1) {
                    return Math.floor(interval) + " Horas";
                }
                interval = seconds / 60;
                if (interval > 1) {
                    return Math.floor(interval) + " Minutos";
                }
                return Math.floor(seconds) + " Segundos";
            },
            url(value) {
                if (value == "" || value == null) {
                    return value;
                }
                return value.substring(0, 30);
            },
            valorPeso(value) {
                if (value == "" || value == null) {
                    return value;
                }
                return new Intl.NumberFormat("es-CO", {
                    currency: "COP",
                }).format(value);
            },
            suscripcion(value) {
                let status = "Suscrito";
                if (value == 1) {
                    status = "Desuscrito";
                }
                return status;
            },
            status(value) {
                let status = "Inactivo";
                if (value) {
                    status = "Activo";
                }
                return status;
            },
            isFullDay (start, end, isMany = false) {
                if (start == '' || start == null || end == '' || end == null) return;
                const possible24Hours = [1439, 1440];
                const condition = isMany
                    ? item => moment(end).diff(moment(start), 'minutes') % item === 0
                    : item => item === moment(end).diff(moment(start), 'minutes');
                return possible24Hours.some(condition);
            },
            cloneJSON (original) {
                return JSON.parse(JSON.stringify(original));
            },
            formatLDate (value) {
                return moment(value).format("DD-MM-YYYY");
            },
            containsSomeValidValue (value) {
                return value != '' && value != null && value != 'null' && value != undefined;
            },
            getDateFormatted (value, formatTo = 'DD-MM-YYYY hh:mm A') {
                return moment(value).format(formatTo);
            }
        };
    },
};
